import { ApiService } from '../../../services/api_service';
import { getCO2AequivalentSubscope1, getCO2AequivalentSubscope2 } from '../../../main/functions/getCO2Aequivalent';
import { getEinheitenForEnergietraeger } from './getEinheitenForEnergietraeger';
import { IDs } from '../../../helpers/IDs';

export function filterBundleForForm(entity: string, key: string, bundleData: any[], row: any, standort: any, globalData?: any,
    onValueChange?: (name: string, value: any, doValidate?: boolean) => void) {
    const modul: string = (globalData || {}).MODUL_SELECTED || null;
    row = row || {};

    if (entity === IDs.ENT_BETRIEBSDATEN && key === 'datenherkunft') {
        return (bundleData || []).filter((item: any) => item.name === 'Rechnung' ? item.name = 'Rechnung / exakt' : true);
    }
    if (entity === IDs.ENT_ENERGIEDATEN_WAERME && key === 'einheit_tid' && bundleData && bundleData.filter) {
        const energietraeger = globalData ? globalData[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] : [];
        const energietraeger_tid = row.energietraeger_tid;
        const energietraeger_obj = energietraeger.find((et: any) => et.tid === energietraeger_tid);
        if (energietraeger_obj) {
            const id = energietraeger_obj.id;
            const arr = getEinheitenForEnergietraeger(id);
            if (!bundleData) {
                return [];
            }
            // console.log('BUNDLEDATA W', bundleData);
            const bundleCopy = bundleData.filter((e: any) =>
                arr.indexOf(e.name) > -1
            );
            if (bundleCopy.length === 1) {
                if (row.einheit_tid !== bundleCopy[0].tid && row.einheit_tid_orig !== bundleCopy[0].tid) {
                    // console.log('BC = 1', key, bundleCopy, row);
                    onValueChange('einheit_tid', bundleCopy[0].tid, false);
                }
            }
            return bundleCopy;
        }
    }
    // "Erdgas [kWh]" und "Wasserstoff [kWh]" sollen nicht erscheinen. Siehe validateFieldKraftstoffe auch.
    if (entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE && key === 'energietraeger_tid' && bundleData && bundleData.filter) {
        const bundleCopy = bundleData.filter((e: any) =>
            ['Erdgas [kWh]', 'Wasserstoff [kWh]'].indexOf(e.name) === -1
            || e.energietraeger_tid === (row || {}).energietraeger_tid
        );
        // Wenn nur eines, dann setzen
        if (bundleCopy.length === 1 && onValueChange && row.energietraeger_tid !== bundleCopy[0].tid) {
            onValueChange('energietraeger_tid', bundleCopy[0].tid, false);
        }
        // Wenn die Auswahl gar nicht in der Liste steht --> entfernen
        if (
            bundleCopy.length > 0 && onValueChange && row.energietraeger_tid > 0
            && !bundleCopy.some((b: any) => b.tid === row.energietraeger_tid)
        ) {
            onValueChange('energietraeger_tid', '', false);
        }
        return bundleCopy;
    }
    // "Erdgas [kWh]" und "Wasserstoff [kWh]" sollen nicht erscheinen. Siehe validateFieldKraftstoffe auch.
    if (entity === IDs.ENT_FAHRZEUGE && key === 'energiedaten_kraftstoff_energietraeger' && bundleData && bundleData.filter) {
        const bundleCopy = bundleData.filter((e: any) =>
            ['Erdgas [kWh]', 'Wasserstoff [kWh]'].indexOf(e.name) === -1
            // || (e.energietraeger_tid === row.energiedaten_kraftstoff_energietraeger ||
            //     e.energietraeger_tid === row.energiedaten_kraftstoff_energietraeger)
        );
        // Wenn nur eines, dann setzen
        if (bundleCopy.length === 1 && onValueChange && row.energiedaten_kraftstoff_energietraeger !== bundleCopy[0].tid) {
            onValueChange('energiedaten_kraftstoff_energietraeger', bundleCopy[0].tid, false);
        }
        // Wenn die Auswahl gar nicht in der Liste steht --> entfernen
        if (
            bundleCopy.length > 0 && onValueChange && row.energiedaten_kraftstoff_energietraeger > 0
            && !bundleCopy.some((b: any) => b.tid === row.energiedaten_kraftstoff_energietraeger)
        ) {
            onValueChange('energiedaten_kraftstoff_energietraeger', '', false);
        }
        // console.log(entity, key, row, bundleCopy, bundleData);
        return bundleCopy;
    }
    if (entity === IDs.ENT_UNTERNEHMENSDATEN && bundleData && bundleData.filter) {
        if (key === 'gewerk_tid') {
            const bundleCopy = bundleData.filter((e: any) =>
                e.name.trim() !== 'Kein Handwerk' || e.tid === row.gewerk_tid_orig
            );
            // console.log(entity, key, bundleCopy);
            return bundleCopy;
        }
        if (key === 'wz_tid') {
            const bundleCopy = bundleData.filter((e: any) =>
                e.gewerk_tid === row.gewerk_tid || e.gewerk_tid_orig === row.gewerk_tid
            );
            // Wenn nur eines, dann setzen
            if (bundleCopy.length === 1 && onValueChange && row.wz_tid !== bundleCopy[0].tid) {
                onValueChange('wz_tid', bundleCopy[0].tid, false); // ACHTUNG: Gewerk "HANDWERKSKAMMER" stürzt hiermit ab...
            }
            // Wenn die Auswahl gar nicht in der Liste steht --> entfernen
            if (bundleCopy.length > 0 && onValueChange && row.wz_tid > 0 && !bundleCopy.some((b: any) => b.tid === row.wz_tid)) {
                onValueChange('wz_tid', '', false);
            }
            return bundleCopy;
        }
        if (key === 'betriebliche_situation') {
            if (row.wz_tid) {
                const wz_liste = globalData[IDs.ENT_GEWERKE_WZ];
                const wz = wz_liste.find((w: any) => w.tid === row.wz_tid);
                const bundleCopy = bundleData.filter((e: any) => {
                    const k = e.tid;
                    return wz && (wz[k]);
                });
                // Wenn nur eines, dann setzen
                if (bundleCopy.length === 1 && onValueChange && row.betriebliche_situation !== bundleCopy[0].tid) {
                    // console.log('setting SIT: ' + bundleCopy[0].tid);
                    onValueChange('betriebliche_situation', bundleCopy[0].tid, false);
                }
                // Wenn die Auswahl gar nicht in der Liste steht --> entfernen
                if (bundleCopy.length > 0 && onValueChange &&
                    row.betriebliche_situation && !bundleCopy.some((b: any) => b.tid === row.betriebliche_situation)) {
                    onValueChange('betriebliche_situation', '', false);
                }
                // console.log('BC bs:' , bundleCopy);
                // Wenn es nicht mal eine Option gibt aber eine Auswahl (von vorher) --> rausnehmen
                if (row.betriebliche_situation && bundleCopy.length === 0) {
                    onValueChange('betriebliche_situation', '', false);
                    console.log('Unsetting BS');
                }
                return bundleCopy;
            }
        }
    }
    if (entity === IDs.ENT_ENERGIEDATEN_EIGENSTROM) {
        if (bundleData && bundleData.filter && key === 'anlagen_eigenstrom_typ_tid') {
            // console.log('BUNDLE-FILTER', key, row, bundleData);
            // Die ausgewählten Typen holen
            const typen_gewaehlt = globalData[IDs.ENT_ANLAGEN_EIGENSTROM];
            // console.log('TGW: ', typen_gewaehlt);
            const bundleCopy = bundleData.filter((item: any) =>
                item.typ === 'S' &&
                typen_gewaehlt && typen_gewaehlt.some((tg: any) => tg.anlagen_eigenstrom_typ_tid_orig === item.tid &&
                    (!standort || tg.standort_tid_orig === standort.tid)));
            if (bundleCopy && bundleCopy.length === 1) {
                if (row.anlagen_eigenstrom_typ_tid !== bundleCopy[0].tid &&
                    row.anlagen_eigenstrom_typ_tid_orig !== bundleCopy[0].tid) {
                    onValueChange('anlagen_eigenstrom_typ_tid', bundleCopy[0].tid, false);
                    // console.log('BC-1', row, bundleData);
                }
            }
        }
        // console.log('Entity/Bundle:', entity, bundleCopy, standort);
    } else {
        // AB HIER CO2 - SCOPE3 ****************************************
        const co2_fussabdruck_ghg = (((globalData || {})[IDs.ENT_KONFIGURATION] || [])[0] || {}).co2_fussabdruck_modus === 'ghg';

        if (entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF) {
            if (key === 'art_tid') {
                const hasKategorie: boolean = !!(row.kategorie_tid_orig || row.kategorie_tid);
                const hasUnterkategorie: boolean = !!(row.unterkategorie_tid_orig || row.unterkategorie_tid);
                if (!hasKategorie || !hasUnterkategorie) {
                    (bundleData || []).forEach((item: any) => {
                        if (item.tid === row.art_tid_orig) {
                            if (!hasKategorie) {
                                // Wir haben eine Art aber keine Kategorie --> Automatisch setzen
                                onValueChange('kategorie_tid', item.kategorie_tid_orig, false);
                                row.kategorie_tid_orig = item.kategorie_tid_orig;
                            }
                            if (!hasUnterkategorie && item.unterkategorie_tid_orig) {
                                // Wir haben eine Art aber keine Unterkategorie --> Automatisch setzen
                                onValueChange('unterkategorie_tid', item.unterkategorie_tid_orig, false);
                                row.unterkategorie_tid_orig = item.unterkategorie_tid_orig;
                            }
                        }
                    });
                }
                if (row.kategorie_tid_orig > 0) {
                    // Im kompakten Modus Materialien nur mit Euro-Faktor filtern
                    // console.log('Bundle Material', bundleData);
                    const hasUnterkategorie: boolean = ((globalData || {})[IDs.ENT_CO2_SCOPE3_FAKTOREN_MATERIAL] || []).some((item: any) =>
                        (item.kategorie_tid_orig || item.kategorie_tid) === (row.kategorie_tid_orig || row.kategorie_tid)
                        && item.unterkategorie_tid
                    );
                    const bundleCopy = (bundleData || []).filter((item: any) =>
                        row.kategorie_tid_orig === item.kategorie_tid_orig
                        && (modul !== 'cfm' || (modul === 'cfm' && item.name !== 'Wasser'))
                        && (!hasUnterkategorie || (item.unterkategorie_tid_orig == (row.unterkategorie_tid_orig || row.unterkategorie_tid || null)))
                        && (co2_fussabdruck_ghg || item.kategorie_tid_orig !== 1 || item.einheit !== 'euro')
                    );
                    if (bundleCopy && bundleCopy.length > 0 && row.art_tid && row.art_tid > 0 && !bundleCopy.find((i: any) => i.tid === row.art_tid)) {
                        row.art_tid = null;
                        onValueChange('art_tid', '', false);
                        onValueChange('modus', '', false);
                    }
                    return bundleCopy;
                } else if (bundleData && bundleData.filter && modul === 'cfm') {
                    const bundleCopy = bundleData.filter((item: any) => item.name !== 'Wasser');
                    return bundleCopy;
                }
            }
            if (key === 'modus') {
                const bundleCopy = [...(bundleData || [])];
                bundleCopy.forEach((r: any) => r.isDisabled = false);
                if (row.art_tid > 0) {
                    // Nur wenn ein Material gewählt wurde
                    const artFnd = globalData[IDs.ENT_CO2_SCOPE3_FAKTOREN_MATERIAL].find((r: any) => r.tid === row.art_tid);
                    const art_tid_name = artFnd ? artFnd.name : null;
                    // Berechnungsmodi deaktivieren
                    const fakt_t = getCO2AequivalentSubscope1(globalData, row.jahr, art_tid_name, 't');
                    const fakt_m3 = getCO2AequivalentSubscope1(globalData, row.jahr, art_tid_name, 'm3');
                    const fakt_stk = getCO2AequivalentSubscope1(globalData, row.jahr, art_tid_name, 'stk');
                    const fakt_euro = getCO2AequivalentSubscope1(globalData, row.jahr, art_tid_name, 'euro');
                    console.log(row, art_tid_name, fakt_t, fakt_m3, fakt_euro);
                    if (!fakt_euro || fakt_euro.invalid) {
                        bundleCopy[2].isDisabled = true;
                        if (row.modus === 'spend_based') {
                            onValueChange('modus', '', false);
                        }
                    }
                    if ((!fakt_t || fakt_t.invalid) && (!fakt_m3 || fakt_m3.invalid) && (!fakt_stk || fakt_stk.invalid)) {
                        bundleCopy[1].isDisabled = true;
                        if (row.modus === 'average_data') {
                            onValueChange('modus', '', false);
                        }
                    }
                } else {
                    bundleCopy[1].isDisabled = true;
                    bundleCopy[2].isDisabled = true;
                }
                if (modul !== 'cfm') {
                    bundleCopy.splice(3, 1); // {3} user_specific
                }
                return bundleCopy;
            }
            if (key === 'kategorie_tid') {
                const bundleCopy = (bundleData || []).filter((item: any) => co2_fussabdruck_ghg || item.tid === 1 || item.tid === 4);
                if (!co2_fussabdruck_ghg) {
                    console.log('Checking Kategorie:  ', row);
                    if (row.kategorie_tid_orig === 1 && (!row.einheit || row.einheit !== 'kg')) {
                        console.log('Kategorie setting kg: ', row);
                        row.einheit = 'kg';
                        onValueChange('einheit', 'kg', true);
                    } else if (row.kategorie_tid_orig === 4 && row.einheit !== 'euro') {
                        console.log('Kategorie setting euro: ', row);
                        row.einheit = 'euro';
                        onValueChange('einheit', 'euro', true);
                    }
                }
                return bundleCopy;
            }
            if (key === 'unterkategorie_tid') {
                const unterkategorien: any = {};
                ((globalData || {})[IDs.ENT_CO2_SCOPE3_FAKTOREN_MATERIAL] || []).forEach((item: any) => {
                    if ((item.kategorie_tid_orig || item.kategorie_tid) === (row.kategorie_tid_orig || row.kategorie_tid) && item.unterkategorie_tid) {
                        unterkategorien[item.unterkategorie_tid_orig || item.unterkategorie_tid] = item;
                    }
                });
                const bundleCopy: any[] = (bundleData || []).filter((item: any) => unterkategorien[item.tid]);
                if (row.unterkategorie_tid > 0 && !bundleCopy.find((i: any) => i.tid === row.unterkategorie_tid)) {
                    // console.log('Unset Unterkategorie: ', row, bundleCopy);
                    row.unterkategorie_tid = null;
                    onValueChange('unterkategorie_tid', '', false);
                }
                return bundleCopy;
            }
            if (key === 'einheit') {
                const bundleCopy = [...(bundleData || [])];
                bundleCopy.forEach((r: any) => r.isDisabled = false);
                if (row.modus === 'average_data') {
                    const artFnd = globalData[IDs.ENT_CO2_SCOPE3_FAKTOREN_MATERIAL].find((r: any) => r.tid === row.art_tid);
                    const art_tid_name = artFnd ? artFnd.name : null;
                    const fakt_t = getCO2AequivalentSubscope1(globalData, row.jahr, art_tid_name, 't');
                    const fakt_m3 = getCO2AequivalentSubscope1(globalData, row.jahr, art_tid_name, 'm3');
                    const fakt_stk = getCO2AequivalentSubscope1(globalData, row.jahr, art_tid_name, 'stk');

                    // console.log(row, art_tid_name, fakt_t, fakt_m3);
                    if (!fakt_t || fakt_t.invalid) {
                        bundleCopy[0].isDisabled = true;
                        bundleCopy[1].isDisabled = true;
                        if (row.einheit === 't' || row.einheit === 'kg') {
                            onValueChange('einheit', '', false);
                        }
                    }
                    if (!fakt_m3 || fakt_m3.invalid) {
                        bundleCopy[2].isDisabled = true;
                        bundleCopy[3].isDisabled = true;
                        if (row.einheit === 'l' || row.einheit === 'm3') {
                            onValueChange('einheit', '', false);
                        }
                    }
                    if (!fakt_stk || fakt_stk.invalid) {
                        bundleCopy[4].isDisabled = true;
                        if (row.einheit === 'stk') {
                            onValueChange('einheit', '', false);
                        }
                    }
                    bundleCopy[5].isDisabled = true; // Euro immer deaktivieren
                    if (row.einheit === 'euro') {
                        onValueChange('einheit', null, false);
                    }
                }
                return bundleCopy;
            }
        } else if (entity === IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL) {
            if (key === 'art_tid' && !row.kategorie_tid_orig && !row.kategorie_tid) {
                // Wir haben eine Art aber keine Kateogrie --> Automatisch seten
                (bundleData || []).forEach((item: any) => {
                    if (item.tid === row.art_tid_orig) {
                        // console.log('OVC', row, item);
                        // row.kategorie_tid = item.kategorie_tid_orig;
                        window.setTimeout(() => onValueChange('kategorie_tid', item.kategorie_tid, false), 100);

                    }
                });
            } else if (key === 'art_tid' && row.kategorie_tid_orig > 0) {
                // console.log('bundleData', bundleData, row);
                const bundleCopy = (bundleData || []).filter((item: any) => row.kategorie_tid_orig === item.kategorie_tid_orig || row.kategorie_tid_orig === item.kategorie_tid);
                if (row.art_tid > 0 && !bundleCopy.find((i: any) => i.tid === row.art_tid)) {
                    row.art_tid = null;
                    onValueChange('art_tid', '', false);
                    onValueChange('modus', '', false);
                }
                return bundleCopy;
            }
            if (key === 'modus') {
                const bundleCopy = [...(bundleData || [])];
                bundleCopy.forEach((r: any) => r.isDisabled = false);
                if (row.art_tid > 0) {
                    // Nur wenn ein Material gewählt wurde
                    const artFnd = globalData[IDs.ENT_CO2_SCOPE3_FAKTOREN_GUETER].find((r: any) => r.tid === row.art_tid);
                    const art_tid_name = artFnd ? artFnd.name : null;
                    // Berechnungsmodi deaktivieren
                    const fakt_t = getCO2AequivalentSubscope2(globalData, row.jahr, art_tid_name, 't');
                    const fakt_stk = getCO2AequivalentSubscope2(globalData, row.jahr, art_tid_name, 'stk');
                    const fakt_euro = getCO2AequivalentSubscope2(globalData, row.jahr, art_tid_name, 'euro');
                    // console.log(row, art_tid_name, fakt_t, fakt_m3, fakt_euro);
                    if (!fakt_euro || fakt_euro.invalid) {
                        bundleCopy[2].isDisabled = true;
                        if (row.modus === 'spend_based') {
                            onValueChange('modus', '', false);
                        }
                    } else if ((!fakt_t || fakt_t.invalid) && (!fakt_stk || fakt_stk.invalid)) {
                        bundleCopy[1].isDisabled = true;
                        if (row.modus === 'average_data') {
                            onValueChange('modus', '', false);
                        }
                    }
                } else {
                    bundleCopy[1].isDisabled = true;
                    bundleCopy[2].isDisabled = true;
                }
                if (modul !== 'cfm') {
                    bundleCopy.splice(3, 1); // {3} user_specific
                }
                return bundleCopy;
            }
            if (key === 'einheit') {
                const bundleCopy = [...(bundleData || [])];
                bundleCopy.forEach((r: any) => r.isDisabled = false);
                if (row.modus === 'average_data') {
                    const artFnd = globalData[IDs.ENT_CO2_SCOPE3_FAKTOREN_GUETER].find((r: any) => r.tid === row.art_tid);
                    const art_tid_name = artFnd ? artFnd.name : null;
                    const fakt_t = getCO2AequivalentSubscope2(globalData, row.jahr, art_tid_name, 't');
                    const fakt_stk = getCO2AequivalentSubscope2(globalData, row.jahr, art_tid_name, 'stk');
                    // console.log(row, art_tid_name, fakt_t, fakt_m3);
                    if (!fakt_t || fakt_t.invalid) {
                        bundleCopy[0].isDisabled = true;
                        bundleCopy[1].isDisabled = true;
                        if (row.einheit === 't' || row.einheit === 'kg') {
                            onValueChange('einheit', '', false);
                        }
                    }
                    if (!fakt_stk || fakt_stk.invalid) {
                        bundleCopy[2].isDisabled = true;
                        if (row.einheit === 'stk') {
                            onValueChange('einheit', '', false);
                        }
                    }
                }
                const bundleCopy2 = bundleCopy.filter((b: any) => !b.isDisabled);
                if (bundleCopy2.length === 1) {
                    // Wenn nur eines, dann setzen
                    const einheit = bundleCopy2[0];
                    if (row.einheit !== einheit.tid) {
                        onValueChange('einheit', einheit.tid);
                    }
                }
                return bundleCopy;
            }
        } else if (entity === IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT || entity === IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT) {
            if (entity === IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT) {
                if (ApiService.bereichKey === 'kultur' && key === 'art') {
                    const bundleCopy = (bundleData || []).map((item: any) => {
                        if (item.tid === 'mobilitaet') {
                            return {
                                ...item,
                                name: 'Mobilität von Dienstleister:innen / Künstler:innen'
                            };
                        }
                        return item;
                    });
                    return bundleCopy;
                }
                if (row.art === 'mobilitaet') {
                    if (bundleData && bundleData.filter && key === 'kraftstoff') {
                        const bundleCopy = bundleData.filter((item: any) => row.transportmittel_mobilitaet !== 'pkw_klein' ||
                            (item.tid !== 'lpg' && item.tid !== 'cng'));
                        return bundleCopy;
                    } else if (bundleData && bundleData.filter && key === 'energietraeger_tid') {
                        const bundleCopy = bundleData.filter((e: any) =>
                            ['Erdgas [kWh]', 'Wasserstoff [kWh]'].indexOf(e.name) === -1
                            || e.energietraeger_tid === (row || {}).energietraeger_tid
                        );
                        return bundleCopy;
                    } else if (bundleData && bundleData.filter && key === 'transportmittel_mobilitaet') {
                        if (row.modus === 'spend_based') {
                            const bundleCopySb = bundleData.filter((item: any) => item.input_group === 'spend_based');
                            return bundleCopySb;
                        } else {
                            const bundleCopySb = bundleData.filter((item: any) => item.input_group !== 'spend_based');
                            return bundleCopySb;
                        }
                    }
                }
            }
            // console.log('TRANSPORT ... ', entity, key,  row, bundleData);
            if (bundleData && bundleData.filter && key === 'modus') {
                if (row.art === 'mobilitaet') {
                    if (row.modus !== 'distance_based') {
                        onValueChange('modus', 'distance_based', true);
                    }
                    return bundleData.filter((item: any) => {
                        if (['fuel_based', 'spend_based', 'user_specific'].indexOf(item.tid) !== -1) {
                            item.isDisabled = true;
                        }
                        return modul === 'cfm' || item.tid !== 'user_specific';
                    });
                }
                if (modul !== 'cfm') {
                    return bundleData.filter((item: any) => item.tid !== 'user_specific');
                }
            } else if (bundleData && bundleData.filter && key === 'transportmittel') {
                if (row.modus === 'spend_based') {
                    if (row.art === 'mobilitaet') {
                        const bundleCopySb = bundleData.filter((item: any) => item.input_group === 'spend_based_mobil');
                        return bundleCopySb;
                    } else {
                        const bundleCopySb = bundleData.filter((item: any) => item.input_group === 'spend_based');
                        return bundleCopySb;
                    }
                }
                const bereichKey: string = ApiService.bereichKey;
                const bundleCopy = bundleData.filter((item: any) => {
                    if (entity === IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT) {
                        return (item.input_group === row.art && (bereichKey === 'kultur' || item.tid !== 'uebernachtung'))
                            || ((!row.art || row.art === '0') && item.input_group === 'gueter');
                    } else {
                        return item.input_group === 'gueter';
                    }
                });
                return bundleCopy;
            } else if (bundleData && bundleData.filter && key === 'transportmittel_mobilitaet') {
                // WKETOOL-99
                if (row.modus === 'spend_based') {
                    const bundleCopySb = bundleData.filter((item: any) => item.input_group === 'spend_based');
                    return bundleCopySb;
                } else {
                    const bundleCopySb = bundleData.filter((item: any) => item.input_group !== 'spend_based');
                    return bundleCopySb;
                }
            } else if (bundleData && bundleData.filter && key === 'energietraeger_tid') {
                const bundleCopy = bundleData.filter((e: any) =>
                    ['Erdgas [kWh]', 'Wasserstoff [kWh]'].indexOf(e.name) === -1
                    || e.energietraeger_tid === (row || {}).energietraeger_tid
                );
                // console.log('Bundle', bundleCopy);
                return bundleCopy;
            }
        } else if (entity === IDs.ENT_CO2_SCOPE3_PENDELN) {
            // console.log('PENDELN ... ', key,  row, bundleData);
            switch (key) {
                case 'modus':
                    if (modul !== 'cfm') {
                        return (bundleData || []).filter((item: any) => item.tid !== 'user_specific');
                    }
                    break;
                case 'transportmittel':
                    return row.modus === 'spend_based'
                        ? (bundleData || []).filter((item: any) => item.input_group === 'spend_based')
                        : (bundleData || []).filter((item: any) => item.input_group !== 'spend_based');
                case 'kraftstoff':
                    return (bundleData || []).filter((item: any) =>
                        row.transportmittel !== 'pkw_klein' || (item.tid !== 'lpg' && item.tid !== 'cng')
                    );
                case 'energietraeger_tid':
                    return (bundleData || []).filter((item: any) =>
                        ['Erdgas [kWh]', 'Wasserstoff [kWh]'].indexOf(item.name) === -1
                        || item.energietraeger_tid === (row || {}).energietraeger_tid
                    );
                case 'groesse':
                    return (bundleData || []).filter((item: any) => row.transportmittel !== 'krad' || item.tid !== 'gross');
            }
        } else if (entity === IDs.ENT_CO2_SCOPE3_REISEN) {
            switch (key) {
                case 'modus':
                    if (modul !== 'cfm') {
                        return (bundleData || []).filter((item: any) => item.tid !== 'user_specific');
                    }
                    break;
                case 'transportmittel':
                    return row.modus === 'spend_based'
                        ? (bundleData || []).filter((item: any) => item.input_group === 'spend_based')
                        : (bundleData || []).filter((item: any) => item.input_group !== 'spend_based');
                case 'kraftstoff':
                    return (bundleData || []).filter((item: any) =>
                        row.transportmittel !== 'pkw_klein' || (item.tid !== 'lpg' && item.tid !== 'cng')
                    );
                case 'energietraeger_tid':
                    return (bundleData || []).filter((item: any) =>
                        ['Erdgas [kWh]', 'Wasserstoff [kWh]'].indexOf(item.name) === -1
                        || item.energietraeger_tid === (row || {}).energietraeger_tid
                    );
            }
        } else if (entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF) {
            // console.log('EINKAUF', key, bundleData);
            if (bundleData && bundleData.filter && key === 'art_tid') {
                const bundleCopy = bundleData.filter((item: any) => item.name !== 'Wasser');
                return bundleCopy;
            }
        } else if (entity === IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_FAHRZEUGE) {
            if (bundleData && bundleData.filter && key === 'energietraeger_tid') {
                const bundleCopy = bundleData.filter((e: any) =>
                    ['Erdgas [kWh]', 'Wasserstoff [kWh]'].indexOf(e.name) === -1
                    || e.energietraeger_tid === (row || {}).energietraeger_tid
                );
                return bundleCopy;
            }
        } else if (entity === IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE) {
            if (bundleData && bundleData.filter && key === 'datenherkunft') {
                const bundleCopy = bundleData.filter((item: any) => item.tid !== 1); // {1} Rechnung
                return bundleCopy;
            }
        } else if (entity === IDs.ENT_ANABREISE) {
            if (bundleData && bundleData.filter && key === 'datenherkunft') {
                const bundleCopy = bundleData.filter((item: any) => item.tid !== 1); // {1} Rechnung
                return bundleCopy;
            }
        } else if (entity === IDs.ENT_CO2_SCOPE3_ABFALL) {
            if (Array.isArray(bundleData)) {
                let bundleCopy = [...bundleData];
                const kategorie = (row || {}).kategorie;
                const unterkategorie = (row || {}).unterkategorie;
                const verfahren = (row || {}).verfahren;
                const modus = (row || {}).modus;
                if (key === 'unterkategorie') {
                    bundleCopy = bundleCopy.filter((item: any) => item.input_group === kategorie);
                    if (onValueChange) {
                        // Wenn die Auswahl gar nicht in der Liste steht --> entfernen
                        if (unterkategorie && !bundleCopy.find((b: any) => b.tid === unterkategorie)) {
                            onValueChange('unterkategorie', '', false);
                            onValueChange('verfahren', '', false);
                        }
                        // Wenn nur eines, dann setzen
                        if (bundleCopy.length === 1 && unterkategorie !== bundleCopy[0].tid) {
                            onValueChange('unterkategorie', bundleCopy[0].tid, false);
                        }
                    }
                    return bundleCopy;
                } else if (key === 'verfahren') {
                    bundleCopy = bundleCopy.filter((item: any) =>
                        typeof item.input_group === 'string' ? item.input_group === unterkategorie
                            : Array.isArray(item.input_group) ? item.input_group.indexOf(unterkategorie) !== -1 : false
                    );
                    const faktoren = (globalData[IDs.ENT_CO2_SCOPE3_FAKTOREN_ABFAELLE] || []).filter((r: any) => r.kategorie === kategorie && r.unterkategorie === unterkategorie);
                    bundleCopy.forEach((b: any) => {
                        const wertKey = `wert_${b.tid}`;
                        const wertFnd = faktoren.find((f: any) => (f.hasOwnProperty(wertKey) && f[wertKey]) || (!f.hasOwnProperty(wertKey) && f.wert));
                        if (modus === 'waste_specific' && !wertFnd) {
                            b.isDisabled = true;
                            // console.log('disabled', unterkategorie, b.tid);
                        } else {
                            b.isDisabled = false;
                        }
                    });
                    if (onValueChange) {
                        const bundleCopy2 = bundleCopy.filter((b: any) => !b.isDisabled);
                        // Wenn die Auswahl gar nicht in der Liste steht --> entfernen
                        if (verfahren && !bundleCopy2.find((b: any) => b.tid === verfahren)) {
                            onValueChange('verfahren', '', false);
                        }
                        // Wenn nur eines, dann setzen
                        if (bundleCopy2.length === 1 && verfahren !== bundleCopy2[0].tid) {
                            onValueChange('verfahren', bundleCopy2[0].tid, false);
                        }
                    }
                    return bundleCopy;
                } else if (key === 'modus') {
                    if (kategorie === 'weitere' /* Freie Eingabe */) {
                        bundleCopy = bundleCopy.filter((item: any) => item.tid !== 'waste_specific');
                    } else {
                        bundleCopy = bundleCopy.filter((item: any) => item.tid !== 'user_specific');
                    }
                    if (onValueChange) {
                        // Wenn die Auswahl gar nicht in der Liste steht --> entfernen
                        if (modus && !bundleCopy.find((b: any) => b.tid === modus)) {
                            onValueChange('modus', '', false);
                        }
                    }
                    return bundleCopy;
                }
            }
        } else if (entity === IDs.ENT_CO2_SCOPE3_FAKTOREN_ABFAELLE) {
            if (Array.isArray(bundleData)) {
                if (key === 'unterkategorie') {
                    const bundleCopy = bundleData.filter((item: any) => item.input_group === (row || {}).kategorie);
                    if (onValueChange && row.unterkategorie && !bundleCopy.find((b: any) => b.tid === row.unterkategorie)) {
                        // Wenn die Auswahl gar nicht in der Liste steht --> entfernen
                        onValueChange('unterkategorie', '', false);
                        onValueChange('verfahren', '', false);
                    }
                    return bundleCopy;
                }
            }
        }
    }
    return bundleData;
}

export function filterBundle(entity: string, bundle: any, data: any, standort: any, formValues?: any) {
    const modul: string = data.MODUL_SELECTED || null;
    const bundleCopy = { ...bundle };
    if (entity === IDs.ENT_ENERGIEDATEN_EIGENSTROM) {
        if (bundle.anlagen_eigenstrom_typ_tid) {
            // Die ausgewählten Typen holen
            const typen_gewaehlt = data[IDs.ENT_ANLAGEN_EIGENSTROM];
            // console.log('TGW: ', typen_gewaehlt);
            bundleCopy.anlagen_eigenstrom_typ_tid = bundle.anlagen_eigenstrom_typ_tid.filter((item: any) =>
                item.typ === 'S' &&
                typen_gewaehlt.some((tg: any) => tg.anlagen_eigenstrom_typ_tid_orig === item.tid &&
                    (!standort || tg.standort_tid_orig === standort.tid)));
            if (bundleCopy.anlagen_eigenstrom_typ_tid && bundleCopy.anlagen_eigenstrom_typ_tid.length === 1) {

            }
        }
        // console.log('Entity/Bundle:', entity, bundleCopy, standort);
    } else if (entity === IDs.ENT_ENERGIEDATEN_STROM) {
        if (Array.isArray(bundleCopy.zaehler_tid)) {
            const medium = getZaehlerMediumPreset(entity);
            bundleCopy.zaehler_tid = bundle.zaehler_tid.filter((z: any) => z.standort_orig === standort.tid && z.medium_orig === medium);
        }
    } else if (entity === IDs.ENT_ENERGIEDATEN_WAERME) {
        if (Array.isArray(bundleCopy.zaehler_tid)) {
            const medium = getZaehlerMediumPreset(entity);
            bundleCopy.zaehler_tid = bundle.zaehler_tid.filter((z: any) => z.standort_orig === standort.tid && z.medium_orig === medium);
        }
        if (modul === 'steuer') {
            const energietraegerId = ['erdgas', 'fluessiggas', 'hel'];
            bundleCopy.energietraeger_tid = bundle.energietraeger_tid.filter((z: any) => energietraegerId.includes(z.id));
        }
    } else if (entity === IDs.ENT_ENERGIEDATEN_WASSER) {
        if (Array.isArray(bundleCopy.zaehler_tid)) {
            const medium = getZaehlerMediumPreset(entity);
            bundleCopy.zaehler_tid = bundle.zaehler_tid.filter((z: any) => z.standort_orig === standort.tid && z.medium_orig === medium);
        }
        if (Array.isArray(bundleCopy.zaehler2_tid)) {
            const medium = getZaehlerMediumPreset(entity);
            bundleCopy.zaehler2_tid = bundle.zaehler_tid.filter((z: any) => z.standort_orig === standort.tid && z.medium_orig === medium);
        }
    } else if (entity === IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE) {
        if (Array.isArray(bundleCopy.fahrzeug_tid)) {
            // console.log('BUNDLE FZG: ', bundleCopy.fahrzeug_tid);
            bundleCopy.fahrzeug_tid = bundle.fahrzeug_tid.filter((f: any) => f.standort_tid_orig === standort.tid);
        }
    } else if (entity === IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_TECHNIK) {
        if (Array.isArray(bundleCopy.energietraeger_tid)) {
            if (formValues && formValues.energietraeger_art === 'weitere') {
                bundleCopy.energietraeger_tid = bundle.energietraeger_tid.filter((r: any) => r.id !== 'strom');
            }
        }
    }
    return bundleCopy;
}

export function getZaehlerMediumPreset(entity: string) {
    switch (entity) {
        case IDs.ENT_ENERGIEDATEN_STROM:
            return 11;
        case IDs.ENT_ENERGIEDATEN_WAERME:
            return 12;
        case IDs.ENT_ENERGIEDATEN_WASSER:
            return 13;
    }
}
